import {
    FRIENDLY_DEPENDENCY_NAMES,
    type FriendlyDependencyName,
} from '../../../constants/dependency';
import translations from '../../../translations';

export const mapFriendlyNameToDisplay = (friendlyName: FriendlyDependencyName) => {
    switch (friendlyName) {
        case FRIENDLY_DEPENDENCY_NAMES.MACRO_ELEMENT:
            return translations.DISPLAY_NAME_macro_element;
        case FRIENDLY_DEPENDENCY_NAMES.PAGE:
            return translations.DISPLAY_NAME_page;
        case FRIENDLY_DEPENDENCY_NAMES.SERVICE_ELEMENT:
            return translations.DISPLAY_NAME_connector;
        case FRIENDLY_DEPENDENCY_NAMES.TYPE_ELEMENT:
            return translations.DISPLAY_NAME_type_element;
        case FRIENDLY_DEPENDENCY_NAMES.VALUE_ELEMENT:
            return translations.DISPLAY_NAME_value_element;
        default:
            return '';
    }
};
